import { SSO_ENDPOINTS, SsoExchangeResult } from '@iws/backoffice-api'

import { httpRequest, stringifyGraph } from '@/clients/http'
import { PosModel } from '@/types'

export const AuthModel = {
  getSystemUid: () =>
    httpRequest<{ system_uid: string }>({
      method: 'get',
      url: '/api/backoffice/system-uid',
    }),

  login: (body: { email: string; password: string }) =>
    httpRequest<{ authorization: { token_type: string; token: string } }>({
      method: 'post',
      url: '/api/backoffice/login',
      body,
    }),

  /** Trades the one-time ticket from admin-dashboard's "Open POS" for a token (SSO, POS.md §12.9.2). */
  ssoExchange: (ticket: string) =>
    httpRequest<SsoExchangeResult>({
      method: 'post',
      url: SSO_ENDPOINTS.exchange,
      body: { ticket },
    }),

  /** The signed-in staff member with roles (permissions) and their branches with terminals (device setup). */
  getProfile: () =>
    httpRequest<{ result: PosModel.StaffProfile }>({
      method: 'get',
      url: '/api/backoffice/profile',
      query: {
        graph_enc: stringifyGraph({
          '*': true,
          roles: { '*': true },
          branches: { '*': true, terminals: { '*': true } },
        }),
      },
    }),
}
